import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, useNavigate, Navigate } from "react-router-dom";
import Fixfile from "./components/covfile/Fixfile";
import SuppliersPage from "./components/covfile/SuppliersPage";
import DescriptionPage from "./components/covfile/DescriptionPage";
import CharacterReplacementPage from "./components/covfile/CharacterReplacementPage";
import SuppliersPagePl from "./components/covfile/SuppliersPagePl";
import SuppliersPageCz from "./components/covfile/SuppliersPageCz";
import Registr from "./components/registr/Registr";
import Profile from "./components/profile/Profile";
import UserProfile from "./components/profile/UserProfile";
import AdminProfile from "./components/profile/AdminProfile";
import Login from "./components/login/Login";
import ForgotPassword from "./components/login/ForgotPassword";
import ResetPassword from "./components/login/ResetPassword";
import Price from "./components/price/Price";
import FopForm from "./components/fopForm/FopForm";
import Fop from "./components/fopForm/Fop";
import ContractorSelector from "./components/fopForm/ContractorSelector";
import HeaderU from "./components/header/HeaderU";
import HeaderA from "./components/header/HeaderA";
import RestForm from "./components/rest/RestoForm";
import RestInfo from "./components/restinfo/RestInfo";
import Historyd from "./components/historyd//Historyd";
import HistorydA from "./components/historyd//HistorydA";
import Bot from "./components/historyd//Bot";
import ConversionFiles from "./components/historyd//ConversionFiles";
import Events from "./components/events/Events";
import { useAuth } from './components/auth/Auth';
import { AuthProvider } from './components/auth/Auth';
import Directory from "./components/directory/Directory";
import Info from "./components/restinfo/RestInfo";
import SInfo from "./components/restinfo/Info";
import UserConfig from "./components/covfile/UserConfig";



function ProtectedRoute({ children, allowedRule }) {
  const { user } = useAuth()
  const userRule = user?.role;
  const isAllowed = String(userRule) === allowedRule;
  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }
  return children
}

function ChooseHeader() {
  const { user } = useAuth()
  const userRule = user?.role;
  if (userRule === 1){
    console.log(user)
    console.log("UserA")
    return <HeaderA />
  }
  return <HeaderU/>
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const refreshToken = localStorage.getItem('refreshToken');
    setIsLoggedIn(!!refreshToken);
  }, []);

  return (
    <BrowserRouter>
      <div className="forFooter">
        <div className="App">
        <AuthProvider>
        <ChooseHeader />
        
          <Routes>
            <Route path="/Fixfile" element={
              <ProtectedRoute allowedRule="0">
                <Fixfile />
              </ProtectedRoute>
            } />
            <Route path="/SuppliersPage" element={
              <ProtectedRoute allowedRule="0">
                <SuppliersPage />
              </ProtectedRoute>
            } />
             <Route path="/DescriptionPagePL" element={
              <ProtectedRoute allowedRule="0">
                <CharacterReplacementPage />
              </ProtectedRoute>
            } />
                  <Route path="/DescriptionPage" element={
              <ProtectedRoute allowedRule="0">
                <DescriptionPage />
              </ProtectedRoute>
            } />
            <Route path="/SuppliersPageCz" element={
              <ProtectedRoute allowedRule="0">
                <SuppliersPageCz />
              </ProtectedRoute>
            } />
             <Route path="/SuppliersPagePl" element={
              <ProtectedRoute allowedRule="0">
                <SuppliersPagePl />
              </ProtectedRoute>
            } />
            

            <Route path="/Registr" element={
              <ProtectedRoute allowedRule="1">
                <Registr />
              </ProtectedRoute>
            } />
            <Route path="/Directory" element={
              <ProtectedRoute allowedRule="1">
                <Directory />
              </ProtectedRoute>
            } />
            <Route path="/UserConfig" element={
              <ProtectedRoute allowedRule="1">
                <UserConfig />
              </ProtectedRoute>
            } />
            {/* <Route path="/Info" element={
              <ProtectedRoute allowedRule="1">
                <Info />
              </ProtectedRoute>
            } /> */}
            
            <Route path="/HistorydA" element={
              <ProtectedRoute allowedRule="1">
                <HistorydA/>
              </ProtectedRoute>
            } />
              <Route path="/Bot" element={
              <ProtectedRoute allowedRule="1">
                <Bot/>
              </ProtectedRoute>
            } />
            <Route path="/ConversionFiles" element={
              <ProtectedRoute allowedRule="1">
                <ConversionFiles/>
              </ProtectedRoute>
            } />
            <Route path="/Profile" element={
              <ProtectedRoute allowedRule="1">
                <Profile />
              </ProtectedRoute>
            } />
            <Route path="/AdminProfile" element={
              <ProtectedRoute allowedRule="1">
                <AdminProfile />
              </ProtectedRoute>
            } />
            <Route path="/Events" element={
              <ProtectedRoute allowedRule="1">
                <Events />
              </ProtectedRoute>
            } />
          
            <Route path="/UserProfile" element={<UserProfile />} />
            <Route path="/Historyd" element={<Historyd />} />
            <Route path="/Fop" element={<Fop/>} />
            <Route path="/ContractorSelector" element={<ContractorSelector/>} />

            <Route path="/Login" element={<Login />} />
            <Route path="/SInfo" element={<SInfo />} />
            <Route path="/ForgotPassword" element={<ForgotPassword />} />
            <Route path="/ResetPassword/:token" element={<ResetPassword />} />
            <Route path="/ResetPassword" element={<ResetPassword />} />
            <Route path="/Price" element={<Price />} />
            <Route path="/RestForm" element={
              <ProtectedRoute allowedRule="1">
                <RestForm />
              </ProtectedRoute>
            } />
            <Route path="/RestInfo" element={
              <ProtectedRoute allowedRule="1">
                <RestInfo/>
              </ProtectedRoute>
            } />
          
            <Route path="/FopForm" element={
              <ProtectedRoute allowedRule="1">
                <FopForm />
              </ProtectedRoute>
            } />
          </Routes>
          </AuthProvider>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;